module.exports = __webpack_public_path__ + "media/images/icon_popup_close-613592f186ac876de666d17c11d57cd7.png";